/**
 * The Type and Order options of the Sankaku Complex / Idol Complex strip (components/sankaku-filter-tabs.tsx), as search words added to
 * what was typed. Measured 2026-10-28 against both APIs: Sankaku takes `file_type:video|image`; Idol Complex ignores `file_type:` (0 posts)
 * and answers to the plain `video` tag, and `-video -animated` leaves pictures. Both take `order:quality` and `order:popular`;
 * `order:random` times out on Idol Complex, so it is left out.
 */
export const SANKAKU_TYPES = ["all", "images", "videos"] as const
export const SANKAKU_ORDERS = ["newest", "quality", "popular"] as const

export function sankakuOptionTerms(siteId: string, options?: Record<string, string>, typed = ""): string {
  const idol = siteId === "idolsankaku"
  const terms: string[] = []
  if (options?.type === "videos") terms.push(idol ? "video" : "file_type:video")
  else if (options?.type === "images") terms.push(idol ? "-video -animated" : "file_type:image")
  // A typed order: word wins over the strip.
  if (!/(^|\s)order:/i.test(typed) && (options?.order === "quality" || options?.order === "popular")) terms.push(`order:${options.order}`)
  return terms.join(" ")
}
